import React from 'react';
import PropTypes from 'prop-types';
import { Page } from '@components';
import { OverviewContent } from '@components/Contents';
import { localizedString } from '@languages';

export default function Overview({ onExit, onStart }) {
  const {
    REMOVE_EXIT_FROM_OVERVIEW = false,
    OVERVIEW_PAGE_TITLE = localizedString('processOverview')
  } = process.env;
  const buttons = [
    {
      label: localizedString('exit'),
      variant: 'outline',
      onClick: () => onExit(),
      dataTestId: 'overview-process-exit'
    },
    {
      label: localizedString('start'),
      onClick: () => onStart(),
      dataTestId: 'overview-process-start'
    }
  ];

  if (REMOVE_EXIT_FROM_OVERVIEW) {
    buttons.shift();
  }

  return (
    <Page title={OVERVIEW_PAGE_TITLE} buttons={buttons}>
      <OverviewContent onClick={() => onStart()} />
    </Page>
  );
}

Overview.propTypes = {
  onStart: PropTypes.func,
  onExit: PropTypes.func
};

Overview.defaultProps = {
  onStart: () => null,
  onExit: () => null
};
